import { Component, HostBinding, Input } from '@angular/core';
import { ControlContainer, FormGroupDirective, ReactiveFormsModule } from '@angular/forms';

import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-input-block',
  imports: [ReactiveFormsModule, TranslateModule],
  templateUrl: './input-block.html',
  styleUrl: './input-block.scss',
  viewProviders: [{ provide: ControlContainer, useExisting: FormGroupDirective }],
})
export class InputBlock {
  @Input({ required: true }) controlId = '';
  @Input() controlName: string | null = null;
  @Input() fullWidth = false;
  @Input() inputType: 'checkbox' | 'email' | 'text' = 'text';
  @Input() invalid = false;
  @Input({ required: true }) labelKey = '';
  @Input() readonly = false;
  @Input() value: string | null = null;

  @HostBinding('class.input-block-full')
  get hostFullWidth(): boolean {
    return this.fullWidth;
  }
}
